import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";

function StartPage() {
  return (
    <Layout>
      <SEO title="Start"
      />

      <section className="w-full px-4 h-screen sm:max-w-6xl mx-auto py-16">
        <h1 className="text-3xl leading-tight font-extrabold text-gray-900 sm:text-4xl text-center">Start Here</h1>
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Hello! I am excited to kick off this journey with you! :)<br></br><br></br>  
          Before we meet, please fill out this {" "}
          <a 
            className="font-bold" 
            href="https://www.notion.so/The-Awesome-Landing-Page-Onboarding-Form-6fe4a28d1e6f42509c3174546246c6f4"
            target="_blank"
            rel="noreferrer"
          >Notion Template</a> and email it to <a className="font-bold" href="mailto:doneforyoulanding@gmail.com">doneforyoulanding@gmail.com</a>. 
          <br></br><br></br>I know it looks a lot but this is a great exercise to go through as you think through how your landing page should look.
          This is true regardless of if you end up working with me or not.
          <br></br><br></br>Best,
          <br></br>Bilal
        </p>                                                                               
      </section>
    </Layout>
  );
}

export default StartPage;        